
import { RevList, RevListItem, RevRadio } from '@backmarket/design-system'

import ProgressBar from '@core/components/ProgressBar'
import { trackClick } from '@tracking/events'

import { TRACKING_ZONE } from '../Page/constants'

import { RATE_RANGES } from './RateFilter.constants'
import translations from './RateFilter.translations'

export default {
  components: {
    ProgressBar,
    RevList,
    RevListItem,
    RevRadio,
  },
  props: {
    ranges: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: String,
      default: RATE_RANGES[0].value,
    },
  },
  data() {
    return {
      selectedRangeValue:
        RATE_RANGES.find(({ value }) => value === this.selected)?.value ||
        RATE_RANGES[0].value,
    }
  },
  computed: {
    translations: () => translations,
    rateRanges() {
      return [{ rateRange: 'between_1_and_5', percentage: 100 }]
        .concat(this.ranges)
        .map(({ rateRange, percentage }, index) => ({
          disabled: percentage === 0,
          label: RATE_RANGES[index].label,
          percentage,
          rateRange,
          value: RATE_RANGES[index].value,
        }))
    },
  },
  methods: {
    handleRangeClick({ value: newValue, rateRange, disabled }) {
      if (!disabled) {
        trackClick({
          pageType: this.$route.name,
          zone: TRACKING_ZONE,
          name: `review_star_filter_${rateRange}`,
        })

        this.selectedRangeValue = newValue
        const [min, max] = newValue.split('-')
        this.$emit('filter', { min, max })
      }
    },
  },
}
